import React, { useState } from 'react';

import { IconButton, Tooltip, Zoom, Divider } from '@material-ui/core';
import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined';
import RotateLeftOutlinedIcon from '@material-ui/icons/RotateLeftOutlined';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => (
    {
      rotate: {
        transition: 'transform 0.3s',
      },
      actionsButtons: {
        marginLeft: '3px',
        marginRight: '3px',
      },
    }
  )
);

export const Rotate = ({ handleRotate }) => {
    const [rotation, setRotation] = useState(0);

    const handleImageClick = (direction) => {
      const angulo = (direction === 'right' ? 90 : -90);

      handleRotate(rotation + angulo);
      setRotation((prevRotation) => prevRotation + angulo);
    };

    return (
      <Rodar rodar={handleImageClick} />
    )
}

export const Rodar = ({ rodar }) => {
  const classes = useStyles();

  return (
    <>
      <Tooltip title="Rodar 90° para a Esquerda" TransitionComponent={Zoom}>
        <IconButton
          color="primary"
          size="small"
          style={{ marginLeft: '3px', marginRight: '3px' }}
          className={classes.actionsButtons}
          aria-label="Rodar 90° para a Esquerda"
          onClick={() => rodar('left')}
        >
          <RotateLeftOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Divider />

      <Tooltip title="Rodar 90° para a Direita" TransitionComponent={Zoom}>
        <IconButton
          color="primary"
          size="small"
          style={{ marginLeft: '3px', marginRight: '3px' }}
          className={classes.actionsButtons}
          aria-label="Rodar 90° para a Direita"
          onClick={() => rodar('right')}
        >
          <RotateRightOutlinedIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}